import { BrowserRouter } from 'react-router-dom';
import 'dayjs/locale/es';

import { LoaderProvider } from './context/LoaderProvider';
import { ToastProvider } from './context/ToastProvider';
import AppProvider from './context/AppProvider';
import AppPrivate from './containers/AppPrivate/AppPrivate';
import './styles/styles.scss';
import 'ypf-pas-general-ui-components/dist/styles.css';

const App = () => (
  <BrowserRouter>
    <ToastProvider>
      <LoaderProvider>
        <AppProvider>
          <AppPrivate />
        </AppProvider>
      </LoaderProvider>
    </ToastProvider>
  </BrowserRouter>
);

export default App;
